import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { orderDetailsAPI } from 'src/app/services/apiRoutes';
import sortHelper from 'src/app/helpers/sort';

@Injectable()
export class ProductsService {
  constructor(public http: HttpClient) {}

  /* products */
  getProducts(id: string) {
    const sort = sortHelper.constructSort([{ prop: 'name', dir: 'asc' }]);
    return this.http.get(orderDetailsAPI + '/' + id + '/product' + sort).toPromise();
  }

  createProduct(id: string, data) {
    return this.http.post(orderDetailsAPI + '/' + id + '/product/', data).toPromise();
  }

  updateProduct(id: string, data) {
    return this.http.put(orderDetailsAPI + '/product/' + data.identifier, data).toPromise();
  }

  deleteProduct(orderId: string, productId: string) {
    return this.http.delete(orderDetailsAPI + '/product/' + productId).toPromise();
  }
  /* products end */
}
